<script setup>
import { computed } from 'vue'
import ActionMenuButton from '../src/ActionMenuButtonMenu.vue'
import { extActionButtonMenuProps } from '../src/props'

const props = defineProps(extActionButtonMenuProps())

const items = computed(() => {
  // match reference: get extension list and levels
  const { extensions = [] } = props.editor?.extensionManager ?? {}
  const levels = props.extension?.options?.levels || []
  const baseKitExt = extensions.find(k => k && k.name === 'base-kit')

  const list = levels.map(level => ({
    action: () => props.editor?.chain?.().focus().toggleHeading({ level }).run(),
    isActive: () => props.editor?.isActive?.('heading', { level }) || false,
    disabled: !(props.editor?.can?.().toggleHeading ? props.editor.can().toggleHeading({ level }) : false),
    icon: `h${level}`,
    title: props.t?.(`editor.heading.h${level}.tooltip`),
  }))

  // include Paragraph item if base-kit has paragraph enabled (default true)
  if (baseKitExt && baseKitExt.options?.paragraph !== false) {
    list.unshift({
      action: () => props.editor?.chain?.().focus().setParagraph().run(),
      isActive: () => props.editor?.isActive?.('paragraph') || false,
      disabled: !(props.editor?.can?.().setParagraph ? props.editor.can().setParagraph() : false),
      icon: 'p',
      title: props.t?.('editor.paragraph.tooltip'),
      divider: true,
    })
  }

  return list
})
</script>

<template>
  <ActionMenuButton
    :editor="editor"
    :items="items"
    :max-height="280"
    :disabled="items.filter(k => k.disabled).length === items.length"
    :tooltip="t && t('editor.heading.tooltip')"
    icon="heading"
  />
</template>
